<template>
    <div class="tabela-vinculo-custom tabela-scroll table-responsive">
        <table class="table table-bordered table-hover mb-0">
            <thead>
                <tr>
                    <th class="text-center align-middle" @click="sort('nomeCompleto')">
                        NOME <i class="fa ml-1" :class="getSortIcon('nomeCompleto')"></i>
                    </th>
                    <th class="text-center align-middle" @click="sort('cpf')">
                        CPF <i class="fa ml-1" :class="getSortIcon('cpf')"></i>
                    </th>
                    <th class="text-center align-middle" @click="sort('cargo')">
                        CARGO <i class="fa ml-1" :class="getSortIcon('cargo')"></i>
                    </th>
                    <th class="text-center align-middle" @click="sort('funcao')">
                        FUNÇÃO <i class="fa ml-1" :class="getSortIcon('funcao')"></i>
                    </th>
                    <th class="text-center align-middle" @click="sort('registroProfissional')">
                        REGISTRO PROFISSIONAL <i class="fa ml-1" :class="getSortIcon('registroProfissional')"></i>
                    </th>
                    <th class="text-center align-middle" style="width: 100px; cursor: default;">
                        AÇÕES
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-if="!sortedItens || sortedItens.length === 0">
                    <td colspan="6" class="text-center">Não existem dados a serem exibidos</td>
                </tr>
                <tr v-for="(item, index) in sortedItens" :key="index">
                    <td class="text-center align-middle">{{ item.nomeCompleto }}</td>
                    <td class="text-center align-middle">{{ item.cpf | toCpfMasked }}</td>
                    <td class="text-center align-middle">{{ item.cargo }}</td>
                    <td class="text-center align-middle">{{ item.funcao }}</td>
                    <td class="text-center align-middle">{{ item.registroProfissional }}</td>
                    <td class="text-center align-middle">
                        <template v-if="editavel">
                            <a href="javascript:void(0)" class="text-primary mr-2" @click="editar(item)" title="Editar">
                                <i class="fa fa-lg fa-info-circle icon-button"></i>
                            </a>
                            <a href="javascript:void(0)" class="text-danger" @click="excluir(item)" title="Excluir">
                                <i class="fa fa-trash fa-lg"></i>
                            </a>
                        </template>
                        <template v-else>
                             <i class="fa fa-lg fa-info-circle text-muted mr-2" title="Edição bloqueada" style="cursor: not-allowed;"></i>
                             <i class="fa fa-trash fa-lg text-muted" title="Exclusão bloqueada" style="cursor: not-allowed;"></i>
                        </template>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    name: 'DeclaracaoVinculoGrid',
    props: {
        itens: {
            type: Array,
            default: () => []
        },
        editavel: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            currentSort: 'nomeCompleto',
            currentSortDir: 'asc'
        }
    },
    computed: {
        sortedItens() {
            if (!this.itens) return [];
            return this.itens.slice().sort((a, b) => {
                let modifier = 1;
                if (this.currentSortDir === 'desc') modifier = -1;
                const valA = (a[this.currentSort] || '').toString().toLowerCase();
                const valB = (b[this.currentSort] || '').toString().toLowerCase();

                if (valA < valB) return -1 * modifier;
                if (valA > valB) return 1 * modifier;
                return 0;
            });
        }
    },
    methods: {
        editar(prof) {
            this.$emit('editar', prof);
        },
        excluir(prof) {
            this.$emit('excluir', prof);
        },
        sort(s) {
            if (s === this.currentSort) {
                this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
            } else {
                this.currentSort = s;
                this.currentSortDir = 'asc';
            }
        },
        getSortIcon(s) {
            if (this.currentSort !== s) return 'fa-sort text-white-50'; 
            if (this.currentSortDir === 'asc') return 'fa-sort-asc text-white';
            return 'fa-sort-desc text-white';
        }
    }
}
</script>

<style>
/* Container com scroll */
.tabela-scroll {
    max-height: 400px;
    overflow-y: auto;
    border: 1px solid #dee2e6;
}

/* Fixa o cabeçalho */
.tabela-vinculo-custom thead th {
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: #2F5597 !important;
    color: #FFFFFF !important;
    text-transform: uppercase;
    font-weight: 600;
    text-align: center;
    cursor: pointer;
    border-top: none !important;
    font-size: 0.75rem;
}

/* Ícone de sort */
.tabela-vinculo-custom thead th i.fa {
    float: right;
    margin-top: 3px;
}

/* Bordas internas */
.tabela-vinculo-custom .table-bordered th,
.tabela-vinculo-custom .table-bordered td {
    border: 1px solid #000 !important;
    vertical-align: middle !important;
    font-size: 0.8rem;
}

.tabela-vinculo-custom tbody {
    color: #000 !important;
}

/* Cor do ícone inativo de sort (semi-transparente) */
.text-white-50 {
    color: rgba(255, 255, 255, 0.5) !important;
}
</style>
